'use client'

import Image from 'next/image'
import { useRouter } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { MButton } from '@/_components/medante/ui/m-button'
import { pushPathWithHash } from '@/_lib/next-link-href'

import ZJobsEyebrow from './z-jobs-eyebrow'

const AJobsSectionTeam = () => {
	const t = useTranslations('pages.letsMakeWorldHealthier.team')
	const router = useRouter()
	// const cdn = process.env.NEXT_PUBLIC_CDN_URL ?? ''

	return (
		<section className='wrapper2 pt-12 pb-6 lg:pt-20 lg:pb-16'>
			<div className='grid grid-cols-1 lg:grid-cols-2 lg:gap-10 gap-8 lg:items-stretch'>
				<div className='flex flex-col justify-center'>
					<ZJobsEyebrow>{t('eyebrow')}</ZJobsEyebrow>
					<h2 className='type-medante-h1'>{t('title')}</h2>
					<div className='page_content reset_margins nobalance mt-4'>
						<p>
							{t.rich('text', {
								br: () => <br />
							})}
						</p>
					</div>
					<div className='flex flex-wrap gap-1 lg:gap-4 mt-6 lg:mt-8 justify-between lg:justify-start'>
						<MButton
							variant='purple'
							onClick={() => {
								pushPathWithHash(router, '/kariera#pozicie')
							}}
						>
							{t('openPositions')}
						</MButton>
						<MButton
							variant='sand'
							onClick={() => {
								router.push('/tim')
							}}
						>
							{t('fullTeam')}
						</MButton>
					</div>
				</div>

				<div className='relative w-full overflow-hidden rounded-3xl min-h-[280px] lg:min-h-[400px] max-w-[460px] lg:max-w-none'>
					<Image
						src={`${process.env.NEXT_PUBLIC_CDN_URL}/assets/images/lets-make-world-healthier/medante-teambuilding.webp`}
						alt={t('imageAlt')}
						fill
						className='object-cover'
						sizes='(max-width: 1024px) min(100vw, 460px), 50vw'
						unoptimized={true}
					/>
				</div>
			</div>
		</section>
	)
}

export default AJobsSectionTeam
